<template>
  <WsCard class="ws-data-multiple-layer-list-item">
    <div v-if="!updateActive">
      <div class="ws-data-multiple-layer-list-item__topbar">
        <p class="ws-data-multiple-layer-list-item__topbar__title">危害性化學品</p>
        <div class="ws-data-multiple-layer-list-item__topbar__btns">
          <WsIconBtn
            @click="$_onUpdateClick()"
            :size="40"
            tooltip="編輯"
          >mdi-pencil</WsIconBtn>
          <WsIconBtn
            @click="$_onDelete(value.id)"
            :size="40"
            tooltip="刪除"
          >mdi-delete</WsIconBtn>
          <WsIconBtn
            v-if="!isEditing"
            @click="$_addOrderClicik()"
            :size="40"
            tooltip="往前"
          >mdi-arrow-up</WsIconBtn>
          <WsIconBtn
            v-if="!isEditing"
            @click="$_reduceOrderClick()"
            :size="40"
            tooltip="往後"
          >mdi-arrow-down</WsIconBtn>
        </div>
      </div>
      <div class="ws-data-multiple-layer-list-item__content-list">
        <div class="ws-data-multiple-layer-list-item__content-list__item">
          標示及通識危害資訊
        </div>
        <div class="ws-data-multiple-layer-list-item__content-list__item">
          標示及通識危害資訊
        </div>
        <div class="ws-data-multiple-layer-list-item__content-list__item">
          標示及通識危害資訊
        </div>
      </div>
    </div>
    <WsAlertDialog
      ref="deleteDialog"
      title="確定要刪除嗎？"
      description="刪除後資料將無法回覆"
      @submit="$_onDeleteSubmit($event)"
    />
    <template v-if="updateActive">
      <div class="ws-data-multiple-layer-list-item__topbar">
        <WsState
          type="text"
          label="章名稱"
        ></WsState>
      </div>
      <div class="ws-data-multiple-layer-list-item__content-list">
        <div class="ws-data-multiple-layer-list-item__content-list__item edit">
          <WsState
            type="text"
            label="節名稱"
          ></WsState>
          <div class="ws-data-multiple-layer-list-item__content-list__item-bar">
            <WsIconBtn
              @click="$_onDelete(value.id)"
              :size="40"
              tooltip="刪除"
            >mdi-delete</WsIconBtn>
            <WsIconBtn
              @click="$_addOrderClicik()"
              :size="40"
              tooltip="往前"
            >mdi-arrow-up</WsIconBtn>
            <WsIconBtn
              @click="$_reduceOrderClick()"
              :size="40"
              tooltip="往後"
            >mdi-arrow-down</WsIconBtn>
          </div>
        </div>
        <div class="ws-data-multiple-layer-list-item__content-list__item">
          <WsBtn
            @click="$_createOpen()"
            color="primary"
            outlined
          >
            <v-icon left>mdi-plus</v-icon> 新增節
          </WsBtn>
        </div>
      </div>
      <v-card-actions class="pa-5">
        <v-spacer></v-spacer>
        <WsBtn
          @click=" $_onUpdateEndClick()"
          minWidth="100px"
          color="textSecondary"
          outlined
        >取消</WsBtn>
        <WsBtn
          @click="$_onUpdateSubmit()"
          minWidth="100px"
          :loading="updateSubmitLoading"
          color="primary"
        >儲存</WsBtn>
      </v-card-actions>
    </template>
  </WsCard>
</template>
<script>
export default {
  name: "WsDataMultipleLayerListItem",
  data: () => ({
    updateActive: false,
    updateSubmitLoading: false,
  }),
  methods: {
    $_onUpdateClick() {
      this.updateActive = true;
      this.$emit("edit", this.value.id);
    },
    $_onUpdateEndClick() {
      this.updateActive = false;
      this.$emit("edit-end", this.value.id);
    },
    $_onUpdateSubmit() {
      console.log("submit");
      this.updateSubmitLoading = true;
      this.$_onUpdateEndClick();
      this.$emit("edit-end", this.value.id);
    },
    $_createOpen() {
      console.log("add");
    },
    $_onDelete($event) {
      this.$refs.deleteDialog.open($event);
    },
    $_onDeleteSubmit($event) {
      this.$refs.deleteDialog.startLoading();
      console.log($event);
    },
    $_addOrderClicik() {
      console.log("add");
    },
    $_reduceOrderClick() {
      console.log("reduce");
    },
  },
  props: {
    isEditing: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Object,
      default() {
        return {};
      },
    },
  },
};
</script>
<style lang="scss">
@import "@/__vue2cmsstonevuetify/assets/scss/ws-data-multiple-layer-list-item";
</style>